import { useEffect, useState } from 'react';
import { distinctUntilChanged, Observable } from 'rxjs';
import {
  FighterFrequency,
  UserTotalPoints,
} from '../../../../corelogic/domain/models/userSeason.model';
import { store } from '../../../../corelogic/state/store';
import {
  getUserSeasonFighterFrequency,
  getUserSeasonFighterFrequencySeasonId,
  getUserSeasonStatsLoading,
  getUserSeasonUsersTotalPoints,
  getUserSeasonUsersTotalPointsSeasonId,
} from '../../../../corelogic/state/userSeason/userSeason.selector';

const fighterFrequencySeasonId$: Observable<string | null> = store.select(
  getUserSeasonFighterFrequencySeasonId,
);
const usersTotalPointsSeasonId$: Observable<string | null> = store.select(
  getUserSeasonUsersTotalPointsSeasonId,
);
const fighterFrequency$: Observable<FighterFrequency[] | null> = store.select(
  getUserSeasonFighterFrequency,
);
const usersTotalPoints$: Observable<UserTotalPoints[] | null> = store.select(
  getUserSeasonUsersTotalPoints,
);
const userSeasonStatsLoading$: Observable<boolean> = store.select(
  getUserSeasonStatsLoading,
);

export const useUserSeasonStatsState = () => {
  const [fighterFrequencySeasonId, setFighterFrequencySeasonId] = useState<
    string | null
  >(null);
  const [usersTotalPointsSeasonId, setUsersTotalPointsSeasonId] = useState<
    string | null
  >(null);
  const [fighterFrequency, setFighterFrequency] = useState<
    FighterFrequency[] | null
  >(null);
  const [usersTotalPoints, setUsersTotalPoints] = useState<
    UserTotalPoints[] | null
  >(null);
  const [userSeasonStatsLoading, setUserSeasonStatsLoading] = useState(false);

  useEffect(() => {
    const fighterFrequencySeasonIdSub = fighterFrequencySeasonId$
      .pipe(distinctUntilChanged())
      .subscribe(setFighterFrequencySeasonId);
    const usersTotalPointsSeasonIdSub = usersTotalPointsSeasonId$
      .pipe(distinctUntilChanged())
      .subscribe(setUsersTotalPointsSeasonId);
    const fighterFrequencySub = fighterFrequency$
      .pipe(distinctUntilChanged())
      .subscribe(setFighterFrequency);
    const usersTotalPointsSub = usersTotalPoints$
      .pipe(distinctUntilChanged())
      .subscribe(setUsersTotalPoints);
    const userSeasonStatsLoadingSub = userSeasonStatsLoading$
      .pipe(distinctUntilChanged())
      .subscribe(setUserSeasonStatsLoading);
    return () => {
      fighterFrequencySeasonIdSub.unsubscribe();
      usersTotalPointsSeasonIdSub.unsubscribe();
      fighterFrequencySub.unsubscribe();
      usersTotalPointsSub.unsubscribe();
      userSeasonStatsLoadingSub.unsubscribe();
    };
  }, []);

  return {
    fighterFrequencySeasonId,
    usersTotalPointsSeasonId,
    fighterFrequency,
    usersTotalPoints,
    userSeasonStatsLoading,
  };
};
